
import { ElNotification } from 'element-plus'
import { defineComponent, h, ref } from 'vue'
import LoginAccount from './login-account.vue'
import LoginPhone from './login-phone.vue'
export default defineComponent({
  name: 'login-panel',
  setup() {
    ElNotification({
      title: '提示',
      message: h(
        'i',
        { style: 'color: teal' },
        '默认账号:coderwhy   默认密码:123456'
      )
    })
    /* 定义属性 */
    const accountRef = ref<InstanceType<typeof LoginAccount>>()
    const phoneRef = ref<InstanceType<typeof LoginPhone>>()
    //绑定 记住密码 值
    const isKeepPsd = ref(false)
    const currentTab = ref('account')
    //登录按钮
    const loginClick = () => {
      if (currentTab.value === 'account') {
        accountRef.value?.loginAction(isKeepPsd.value)
      } else {
        phoneRef.value?.loginAction(isKeepPsd.value)
      }
    }
    return {
      isKeepPsd,
      loginClick,
      accountRef,
      phoneRef,
      currentTab
    }
  },
  components: {
    LoginAccount
  }
})
